const {
  VITE_API_URL,
  VITE_BOLT_BACKEND_URL,
  VITE_CMS_URL,
  VITE_GMAP_KEY,
  VITE_NODE_ENV,
  VITE_SYSTEM_DOWN,
  VITE_WEBSITE_URL,
  VITE_CLOUDINARY_CLOUD_NAME,
  VITE_DEBUG_ACCOUNT_SELECTION_AS_REGULAR_USER,
  VITE_DEBUG_I18N,
  VITE_DEBUG_POSTHOG,
  VITE_TESTING,
  VITE_POSTHOG_KEY,
  VITE_POSTHOG_HOST,
  VITE_POSTHOG_DEV_ENABLED,
  VITE_VERCEL_ENV,
  VITE_CMS_FETCH_DRAFTS,
  VITE_PRODUCTION_TESTING,
  VITE_SENTRY_DSN
} = import.meta.env

export const API_URL = VITE_API_URL ?? ''
export const BOLT_BACKEND_URL = VITE_BOLT_BACKEND_URL ?? ''
export const NODE_ENV = VITE_NODE_ENV || 'local'
export const VERCEL_ENV = VITE_VERCEL_ENV || 'development'
export const GMAP_KEY = VITE_GMAP_KEY
export const CMS_URL = VITE_CMS_URL
export const CMS_FETCH_DRAFTS = VITE_CMS_FETCH_DRAFTS
export const WEBSITE_URL = VITE_WEBSITE_URL
export const SYSTEM_DOWN = VITE_SYSTEM_DOWN === 'true'
export const CLOUDINARY_NAME = VITE_CLOUDINARY_CLOUD_NAME
export const SENTRY_DSN = VITE_SENTRY_DSN
export const IS_TESTING = VITE_TESTING === 'true'
export const POSTHOG_KEY = VITE_POSTHOG_KEY
export const POSTHOG_HOST = VITE_POSTHOG_HOST
export const POSTHOG_DEV_ENABLED_TRACKING = VITE_POSTHOG_DEV_ENABLED === 'true'

// Debugging
export const DEBUG_ACCOUNT_SELECTION_AS_REGULAR_USER = VITE_DEBUG_ACCOUNT_SELECTION_AS_REGULAR_USER === 'true'
export const DEBUG_I18N = VITE_DEBUG_I18N === 'true'
export const DEBUG_POSTHOG = VITE_DEBUG_POSTHOG === 'true'

// Environment checks
export const IS_PRODUCTION = VERCEL_ENV === 'production'
export const IS_BETA = NODE_ENV === 'beta'
export const IS_STAGING = NODE_ENV === 'staging'
export const IS_PREVIEW = NODE_ENV === 'preview'
export const IS_LOCAL = NODE_ENV === 'local'
export const IS_PROD_OR_BETA = IS_BETA || IS_PRODUCTION
export const IS_STAGING_OR_PREVIEW = IS_STAGING || IS_PREVIEW

// Production testing
export const IS_PROD_TESTING = VITE_PRODUCTION_TESTING === 'true'
